import LocomotiveScroll from 'locomotive-scroll';
class ScrollHandler {
  constructor() {
    this.scrollInstance = null;
    this.isScrollLocked = false;
  }
  init(onScrollUp, onScrollDown, onScroll) {
    this.scrollInstance = new LocomotiveScroll({
      scrollCallback: ({
        direction,
        scroll
      }) => {
        if (direction === 1) {
          onScrollDown(scroll);
        } else {
          onScrollUp(scroll);
        }
        onScroll(scroll, direction);
      }
    });
  }
  scrollEnable() {
    this.scrollInstance.start();
    this.isScrollLocked = false;
  }
  scrollDisable() {
    this.scrollInstance.stop();
    this.isScrollLocked = true;
  }
  toggleScroll() {
    if (this.isScrollLocked) {
      this.scrollEnable();
    } else {
      this.scrollDisable();
    }
  }
}
const scroll = new ScrollHandler();
export default scroll;